module.exports = __webpack_public_path__ + "img/sidebar.0e88bae4.svg";